import { defineComponent as _defineComponent } from 'vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    GraphicChevrons: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'GraphicChevrons' };

import { computed } from 'vue';
import type { StyleValue } from 'vue/types/jsx';

import { isString } from '@tools/type-guards';

/**
 * ...
 */
export interface Element {
  index: number;
}

/**
 * `GraphicChevrons` component properties.
 */
export interface Props {
  color?: string;
  elements?: number;
  x?: string | number;
  y?: string | number;
  rotation?: number;
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    color: { default: '#48e5c240' },
    elements: { default: 6 },
    x: { default: 50 },
    y: { default: 50 },
    rotation: { default: -45 }
  },
  setup(__props: any) {

const props = __props as { color: string, elements: number, x: string | number, y: string | number, rotation: number };



/** ... */
const graphicStyle = computed(() => {
  const style: StyleValue = {};

  style.left = isString(props.x) ? props.x : `${props.x.toString()}%`;

  style.top = isString(props.y) ? props.y : `${props.y.toString()}%`;

  style.color = props.color;

  style.transform = `rotateZ(${props.rotation}deg)`;

  return style;
});

/** ... */
const elementItems = computed(() => {
  const items: Element[] = [];

  for (let i = 0; i <= props.elements - 1; i++) {
    items.push({ index: i });
  }

  return items;
});

return { __sfc: true,props, graphicStyle, elementItems }
}

})